  $('.js-toc').each(
    ()->
      if $(this).hasClass('js-accordion')
        $(this).find('> .js-accordion-contents').css({
          'height': $(this).find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()
          'max-height': $(this).find('> .js-accordion-contents > .js-accordion-contents-inner').outerHeight()
          'transition-duration': '0s'
        })
  )
  